import { useMemo } from 'react';

import { WheelsVehicle } from '../../domain/wheels';
import { useWheelsPricingConfig } from '../../features/wheels/hooks';

// ********************************************************************************
// Hook that formats the config data for the wheels routes table, its main purpose
// is to give table-friendly data to the WheelsRoutesTable component
// For the raw pricing config data, see use-wheels-pricing-config.tsx
export type VechicleRoute = { zone: string; price: number };
type Routes = Record<WheelsVehicle, VechicleRoute[]>;
export const useWheelsRoutesTable = () => {
  const { pricingConfig } = useWheelsPricingConfig();
  const routes = useMemo<Routes>(() => {
    const formatted: Routes = {
      [WheelsVehicle.Sedan]: [],
      [WheelsVehicle.Suv]: [],
      [WheelsVehicle.Transit]: [],
    };
    if (!pricingConfig) return formatted /*empty*/;

    const { pricing, zones } = pricingConfig;
    pricing.forEach(({ prices, zone }) => {
      // Display name of the zone
      const displayName = zones.find((z) => z.name === zone)?.display;
      if (!displayName) return /*invalid zone*/;

      prices.forEach(({ vehicleType, price }) => {
        formatted[vehicleType].push({
          zone: displayName,
          price,
        });
      });
    });

    // Sort the zones by name
    Object.keys(formatted).forEach((key) => {
      formatted[key].sort((a: VechicleRoute, b: VechicleRoute) => a.zone.localeCompare(b.zone));
    });

    return formatted;
  }, [pricingConfig]);

  return { routes };
};
